import {
  sanitizeEmbedHtml,
  sanitizeRenderedHtml,
  sanitizeRichHtml,
} from '@/lib/sanitizeHtml';

function render(el, { value, modifiers }) {
  const html = value == null ? '' : String(value);
  if (modifiers.embed) {
    el.innerHTML = sanitizeEmbedHtml(html);
  } else if (modifiers.rich) {
    el.innerHTML = sanitizeRichHtml(html);
  } else {
    el.innerHTML = sanitizeRenderedHtml(html);
  }
}

// Sanitized v-html; .embed allows one Embedly CDN iframe, .rich keeps Quill colours.
export default {
  bind: render,
  update(el, binding) {
    if (binding.value !== binding.oldValue) render(el, binding);
  },
};
